import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  main: {
    height: '100vh'
  },
  root: { height: '100%' },
  filtersContainer: { margin: '16px 0' },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16
  },
  title: { fontWeight: 500, fontSize: 18, color: theme.palette.text.primary },
  subTitle: { fontWeight: 500, fontSize: 14 },
  buttonContainer: {
    marginTop: 30,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  content: { padding: '16px 0', marginBottom: 60 },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '40vh',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    margin: '-23px -96px',
    padding: '24px 130px 24px 96px',
    background: theme.palette.background.default,
    borderTop: `2px solid ${theme.palette.grey[300]}`,
    position: 'fixed',
    width: '100%',
    bottom: 24,
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      // margin: '-22px -16px 0px -16px',
      // overflow: 'visible',
      // alignSelf: 'unset'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  subtitle: { fontSize: 18, marginTop: 16 },
  redText: { color: theme.palette.primary.main, fontWeight: 500, fontSize: 16 },
  whiteText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: 16
  },
  cancelBtn: { margin: '0 8px' },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}))
export default useStyles
